import { COLORS, fontFamilyFor } from "../../theme";

// Mirrors new-design's .site-footer (about/pricing/how-it-works/
// contact-sales.html) — a single centered link row + copyright, distinct
// from the homepage's big 4-column Footer.
export const Style = {
  footer: {
    borderTop: "1px solid rgba(255,255,255,0.08)",
    padding: { xs: "32px 20px", md: "48px" },
    textAlign: "center",
    color: "rgba(255,255,255,0.45)",
    fontSize: "14px",
    mt: "48px",
  },
  links: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "32px",
    mb: "20px",
  }),
  link: (isArabic) => ({
    color: "rgba(255,255,255,0.65)",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "15px",
    cursor: "pointer",
    "&:hover": { color: COLORS.peach },
  }),
};
